import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import SiteSeller from './site/SiteSeller';
import SiteMarketing from './site/SiteMarketing';
import VideoPage from './video/VideoPage';
import UsersPage from './users/UsersPage';
import UnsubscribePage from './unsubscribe/UnsubscribePage';
import UpcomingShowPage from './upcomingshow/UpcomingShowPage';
import SellerPage from './seller/SellerPage';
import { init } from './firestore';
import ReviewPage from './reviews/ReviewPage';

const useInit = () => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    init().then(() => setReady(true));
  }, []);
  return ready;
};

const App = () => {
  const ready = useInit();
  if (!ready) {
    return null;
  }
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/seller" exact={true} component={SellerPage} />
        <Route path="/site/marketing" exact={true} component={SiteMarketing} />
        <Route path="/site/" component={SiteSeller} />
        <Route path="/video/" component={VideoPage} />
        <Route path="/users/" component={UsersPage} />
        <Route path="/unsubscribe/" component={UnsubscribePage} />
        <Route path="/upcomingshow/" component={UpcomingShowPage} />
        <Route path="/reviews/:reviewId" component={ReviewPage} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
